export default {
      id: "Icon--trackStart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--trackStart",
      toString: function () {
        return this.url;
      }
    }